import PropTypes from 'prop-types'

const propTypes = {
  process: PropTypes.object.isRequired,
}

export default propTypes
